/* EventManager, v1.0.1
 *
 * Copyright (c) 2009, Howard Rauscher
 * Licensed under the MIT License
 *
 * https://gist.github.com/howardr/118668
 */

function ApxEventManager() {
    this._listeners = {};
}

ApxEventManager.prototype = {
    addListener: function (name, fn) {
        (this._listeners[name] = this._listeners[name] || []).push(fn);
        return this;
    },
    removeListener: function (name, fn) {
        if (arguments.length === 1) { // remove all
            this._listeners[name] = [];
        } else if (typeof (fn) === 'function') {
            var listeners = this._listeners[name];
            if (listeners !== undefined) {
                var foundAt = -1;
                for (var i = 0, len = listeners.length; i < len && foundAt === -1; i++) {
                    if (listeners[i] === fn) {
                        foundAt = i;
                    }
                }

                if (foundAt >= 0) {
                    listeners.splice(foundAt, 1);
                }
            }
        }

        return this;
    },
    fire: function (name, args) {
        var listeners = this._listeners[name];
        args = args || [];
        if (listeners !== undefined) {
            var evt;
            for (var i = 0, len = listeners.length; i < len; i++) {
                evt = new ApxEventManager.EventArg(name, args);

                listeners[i].call(window, evt);

                if (evt.removed) {
                    listeners.splice(i, 1);
                    len = listeners.length;
                    --i;
                }
                if (evt.cancelled) {
                    break;
                }
            }
        }
        return this;
    },
    hasListeners: function (name) {
        return (this._listeners[name] === undefined ? 0 : this._listeners[name].length) > 0;
    }
};
ApxEventManager.eventify = function (object, manager) {
    var methods = ApxEventManager.eventify.methods;
    manager = manager || new ApxEventManager();

    for (var i = 0, len = methods.length; i < len; i++)(function (method) {
        object[method] = function () {
            return manager[method].apply(manager, arguments);
        };
    })(methods[i]);

    return manager;
};
ApxEventManager.eventify.methods = ['addListener', 'removeListener', 'fire'];

ApxEventManager.EventArg = function (name, data) {
    this.name = name;
    this.data = data;
    this.cancelled = false;
    this.removed = false;
};
ApxEventManager.EventArg.prototype = {
    cancel: function () {
        this.cancelled = true;
    },
    remove: function () {
        this.removed = true;
    }
};

export {
    ApxEventManager
};